import { atom } from "recoil";

export const personalPromotionsStatsModalStore = atom({
  key: "personalPromotionsStatsModalStore",
  default: {
    show: false,
    loaded: false,
    data: null,
    error: {
      text: "",
      code: 0,
      timestamp: 0,
    },
  },
});